// TEMPORARY (2026-11-01): images.hsingh.app is returning 503 for every request,
// so images load straight from the CDN. To restore the resizing proxy, revert to
// src/backups/image-loader.pre-proxy-bypass.2026-11-01.ts.bak.
const PROXY = "";

export default function imageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  // No proxy configured — return src directly
  if (!PROXY) return src;

  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}&output=webp`;
}
